// Auto-generated by scripts/generate-registry.mjs from packages/modules/core_e27_shade/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const core_e27_shade: ModuleSchema = {
  "id": "core_e27_shade",
  "uniqueId": "B3D_E27SH",
  "createdAt": "2026-10-02T06:01:02.382Z",
  "updatedAt": "2026-10-28T14:58:31.619Z",
  "label": "E27 Shade",
  "description": "core_e27_shade parametric 3D model",
  "category": "core_geometry",
  "tags": [
    "core-geometry",
    "CG_E27"
  ],
  "sliders": [
    {
      "key": "shadeDia",
      "label": "Lampshade Diameter (Ø)",
      "min": 80,
      "max": 160,
      "step": 1,
      "default": 110,
      "unit": "mm"
    },
    {
      "key": "shadeH",
      "label": "Lampshade Height",
      "min": 80,
      "max": 240,
      "step": 2,
      "default": 170,
      "unit": "mm"
    },
    {
      "key": "shadeWall",
      "label": "Wall Thickness",
      "min": 1.5,
      "max": 4,
      "step": 0.5,
      "default": 2,
      "unit": "mm"
    },
    {
      "key": "bottomThick",
      "label": "Bottom Disc Thickness",
      "min": 2,
      "max": 6,
      "step": 0.5,
      "default": 2,
      "unit": "mm"
    },
    {
      "key": "holeDia",
      "label": "Center E27 Hole (Ø)",
      "min": 38,
      "max": 45,
      "step": 0.5,
      "default": 41.5,
      "unit": "mm"
    },
    {
      "key": "patternType",
      "label": "Pattern (0:Circle, 1:Pentagon, 2:Diamond)",
      "min": 0,
      "max": 2,
      "step": 1,
      "default": 0,
      "unit": ""
    },
    {
      "key": "patternSize",
      "label": "Pattern Hole Size",
      "min": 4,
      "max": 16,
      "step": 0.5,
      "default": 8,
      "unit": "mm"
    },
    {
      "key": "patternRows",
      "label": "Pattern Rows",
      "min": 6,
      "max": 24,
      "step": 1,
      "default": 16,
      "unit": ""
    },
    {
      "key": "patternCols",
      "label": "Pattern Columns",
      "min": 6,
      "max": 20,
      "step": 1,
      "default": 12,
      "unit": ""
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "e27_shade",
      "label": "E27 Perforated Lampshade",
      "default": "#f3f4f6",
      "targetGroupIds": [
        0
      ]
    }
  ],
  "objects": [
    {
      "id": "e27_shade_obj",
      "label": "E27 Lampshade",
      "name": "E27 Lampshade",
      "color": "#f3f4f6",
      "assembled_z_offset": 0,
      "exploded_z_offset": 25,
      "parts": [
        {
          "id": "e27_shade",
          "label": "E27 Perforated Lampshade",
          "name": "E27 Perforated Lampshade",
          "groupId": 0,
          "colorKey": "e27_shade",
          "defaultColor": "#f3f4f6",
          "assembled_z_offset": 0,
          "exploded_z_offset": 25,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": []
};
